import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})

export class IdleTimeoutService {
  private idleTime: number = 0; // tempo de inatividade em segundos
  private idleLimit: number = 0; // limite de inatividade em segundos 300
  private idleWarningTime: number = 0; // aviso de inatividade em segundos

  private idleTimer: any;
  private interactionSubject = new Subject<void>();
  private eventsSubscription: Subscription | null = null;

  private messageSessao = false;

  constructor(private router: Router,  private http: HttpClient) {
    this.listenToUserInteractions();
  }

  loadConfig(): Observable<any> {
    return this.http.get('/assets/config.json');
  }

  start() {
    this.loadConfig().subscribe(config => {
      this.idleLimit = config.idleLimit;
      this.idleWarningTime = config.idleWarningTime;
    });

    this.resetIdleTime();
    this.startIdleTimer();

    this.eventsSubscription = this.interactionSubject
      .pipe(debounceTime(500))
      .subscribe(() => this.resetIdleTime());
  }

  private startIdleTimer() {
    clearInterval(this.idleTimer);
    this.idleTimer = setInterval(() => this.checkIdleStatus(), 1000);
  }

  private listenToUserInteractions() {
    const resetEvents = (event: Event) => {
      this.interactionSubject.next();
    };

    window.addEventListener('mousemove', resetEvents);
    window.addEventListener('keydown', resetEvents);
    window.addEventListener('scroll', resetEvents);
    window.addEventListener('click', resetEvents);
  }

  private  async checkIdleStatus(): Promise<void> {
    this.idleTime++;

    if (this.idleTime >= this.idleLimit)
    {
      this.logout();

    }
    else if (this.idleTime >= this.idleLimit - this.idleWarningTime)
    {
      if(this.messageSessao == false)
      {
        const result = this.showCustomDialog("A sessão vai ser interrompida por falta de ação! Quer continuar na sessão?");

        if (await result) {
          this.messageSessao = false;
          this.resetIdleTime();

        } else {
          this.messageSessao = false;
          this.logout();

        }
      }
    }
  }

  private resetIdleTime() {
    this.idleTime = 0;
  }

  private logout() {
    localStorage.removeItem('userData');
    this.stop();
    this.router.navigate(['/']);
  }

  stop() {
    clearInterval(this.idleTimer);
    if (this.eventsSubscription) {
      this.eventsSubscription.unsubscribe();
      this.eventsSubscription = null;
    }
  }

  showCustomDialog(message: string): Promise<boolean> {
    this.messageSessao = true;

    return new Promise((resolve) => {
      // Criação do container principal
      const dialogOverlay = document.createElement('div');
      dialogOverlay.style.position = 'fixed';
      dialogOverlay.style.top = '0';
      dialogOverlay.style.left = '0';
      dialogOverlay.style.width = '100%';
      dialogOverlay.style.height = '100%';
      dialogOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
      dialogOverlay.style.display = 'flex';
      dialogOverlay.style.alignItems = 'center';
      dialogOverlay.style.justifyContent = 'center';
      dialogOverlay.style.zIndex = '1000';

      // Criação do box de diálogo
      const dialogBox = document.createElement('div');
      dialogBox.style.backgroundColor = 'white';
      dialogBox.style.padding = '20px';
      dialogBox.style.borderRadius = '8px';
      dialogBox.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.2)';
      dialogBox.style.textAlign = 'center';

      // Adiciona a mensagem ao diálogo
      const messageElement = document.createElement('p');
      messageElement.textContent = message;
      dialogBox.appendChild(messageElement);

      // Botão "Sim"
      const yesButton = document.createElement('button');
      yesButton.textContent = 'Sim';
      yesButton.style.margin = '0 10px';
      yesButton.style.padding = '10px 20px';
      yesButton.style.fontSize = '14px';
      yesButton.addEventListener('click', () => {
        resolve(true);
        document.body.removeChild(dialogOverlay); // Remove o diálogo
      });
      dialogBox.appendChild(yesButton);

      // Botão "Não"
      const noButton = document.createElement('button');
      noButton.textContent = 'Não';
      noButton.style.margin = '0 10px';
      noButton.style.padding = '10px 20px';
      noButton.style.fontSize = '14px';
      noButton.addEventListener('click', () => {
        resolve(false);
        document.body.removeChild(dialogOverlay); // Remove o diálogo
      });
      dialogBox.appendChild(noButton);

      // Adiciona o diálogo ao overlay
      dialogOverlay.appendChild(dialogBox);

      // Adiciona o overlay ao corpo do documento
      document.body.appendChild(dialogOverlay);
    });
  }

}
